import type { EventConfig } from "../types";

export const eventConfig: EventConfig = {
  id: "health-wellness-expo-bacchus-marsh-2026",
  name: "Health & Wellness Expo",
  location: "Bacchus Marsh, Victoria",
  eventDateLabel: "30 August 2026",
  timezone: "Australia/Melbourne",
  opensAt: "2026-08-30T00:00:00+10:00",
  closesAt: "2026-09-06T23:59:00+10:00",
  drawAt: "2026-09-07T10:00:00+10:00",
  drawLocation: "Prahran, Victoria 3181",
  redrawAt: "2026-09-21T10:00:00+10:00",
  redrawLocation: "Prahran, Victoria 3181",
  eligibility: {
    regions: ["Victoria"],
    minimumAge: 18,
  },
  prize: {
    title: "Terpene Wellness Gift Pack",
    contents: [
      "one Monday–Sunday Calm + Sleep two-bottle bundle",
      "candles",
      "slippers",
      "essential oils",
    ],
    valueAud: 110,
  },
  referralLimit: 5,
  termsVersion: "2026-08-26-v2",
  consentWordingVersion: "2026-08-26-v2",
  landingUrl: "https://quiz.roottorise.com.au/",
  contactEmail: "hello@roottorise.com.au",
  closedContent: {
    heading: "The giveaway has closed",
    body: "You can still discover your terpene personality and explore your Calm or Sleep match.",
  },
};

export function isGiveawayOpen(now = new Date()): boolean {
  return now >= new Date(eventConfig.opensAt) && now <= new Date(eventConfig.closesAt);
}

export function isGiveawayUpcoming(now = new Date()): boolean {
  return now < new Date(eventConfig.opensAt);
}
